<template>
<div class="dataManagement as2sa">
  <div class="left">
    <div class="searchBox">
      <el-input v-model="pageParams.name" placeholder="搜索数据源" clearable prefix-icon="el-icon-search" class="searchInput" @input="searchTable"></el-input>
      <el-tooltip content="类型筛选" placement="top" effect="light" :open-delay="1000">
        <el-popover
            popper-class = 'custom-popover'
            placement="bottom-start"
            trigger="click"
            :open-delay="100"
        >
          <div class="popover-content typeCheckList">
            <el-checkbox-group v-model="typeCheckList" @change = 'changeTypeCheckList'>
              <el-checkbox label="EXCEL">EXCEL</el-checkbox>
              <el-checkbox label="API">API接口</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="filter" slot="reference">
            <Icon name="icon-shaixuan" type="big"></Icon>
          </div>
        </el-popover>
      </el-tooltip>
      <el-tooltip content="添加数据源" placement="top" effect="light" :open-delay="1000">
        <div class="add" @click="onShowAddDialog" :disabled="permissionLevel <= PermissionLevel.LOOKER"><i class="el-icon-plus"></i></div>
      </el-tooltip>
    </div>
    <div class="ul-box">
      <ul class="dataList">
        <el-tooltip :content="item.name" placement="top" effect="light" v-for="(item,index) in dataList" :key="index" :open-delay="1000" :enterable="false">
          <li :class="activeIndex === index?'active':''" @click="handleClick(index, item)">
            <svg width="18px" height="18px" aria-hidden="true" style="margin-right: 4px;opacity: 1;">
              <use xlink:href="#icon-excel_a" v-if="item.label"></use>
              <use xlink:href="#icon-API" v-else-if="item.dataSourceType==='API'"></use>
              <use xlink:href="#icon-Excel" v-else></use>
            </svg>
            <span class="name">{{item.name}}<span v-if="item.suffix">.{{item.suffix}}</span></span>
            <div @click.stop="setShowId(item)">
              <el-dropdown trigger="click" placement="bottom-start" :hide-on-click="true">
                <span class="el-dropdown-link">
                  <span class="more" slot="reference">
                    <Icon type="big" name="el-icon-more"></Icon>
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <div class="popover-content">
                    <el-dropdown-item @click.native="rename(item)" :disabled="permissionLevel <= PermissionLevel.LOOKER">重命名</el-dropdown-item>
<!--                    <el-dropdown-item><a :href="baseurl + 'map/data/download?id=' + item.id" class="exportBtnByDataManagement">导出</a></el-dropdown-item>-->
                    <el-dropdown-item v-if="item.dataSourceType==='EXCEL'" :disabled="permissionLevel <= PermissionLevel.LOOKER"><span @click="downloadFile(baseurl + 'map/dataSources/download?id=' + item.id, item.name)">导出</span></el-dropdown-item>
                    <el-dropdown-item @click.native="deleteTable(item.id)" :disabled="permissionLevel <= PermissionLevel.LOOKER">删除</el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="my-popover"></div>
          </li>
        </el-tooltip>
      </ul>
    </div>
  </div>
  <div class="right" v-if="dataList && dataList.length>0">
    <div class="head" v-if="dataName">
      <svg width="20px" height="18px" aria-hidden="true" style="margin-right: 4px;">
        <use xlink:href="#icon-excel_a" v-if="dataLabel"></use>
        <use xlink:href="#icon-API" v-else-if="dataSourceType==='API'"></use>
        <use xlink:href="#icon-Excel" v-else></use>
      </svg>
      <span>{{dataName}} 数据源</span>
      <el-button type="primary" class="addBtn" @click="openAddForm" v-if="!dataLabel && dataSourceType==='EXCEL'" :disabled="permissionLevel <= PermissionLevel.LOOKER">新增</el-button>
      <el-button type="primary" class="addBtn" @click="showApiEditDialog=true" v-if="dataSourceType==='API'" :disabled="permissionLevel <= PermissionLevel.LOOKER">编辑</el-button>
    </div>
    <div class="total" v-show="dataSourceType === 'EXCEL'">
      共<span>{{total}}</span>条记录
    </div>
    <!-- EXCEL表数据 -->
    <div class="table-box" v-if="tableData.length && dataSourceType === 'EXCEL'">
      <el-table
        v-if="keep"
        ref="multipleTable"
        stripe
        :data="tableData"
        height="100%"
        tooltip-effect="dark"
        style="width: 100%"
        v-el-table-infinite-scroll="loadMore"
      >
        <el-table-column label="序号" :width="50*zoomFactor">
          <template slot-scope="scope">
            <span class="num">{{scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column
            v-for="(item ,index) in columns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            show-overflow-tooltip
            :align="item.type==='NUMBER'?'right':'left'"
            header-align="left"
        >
        </el-table-column>
        <el-table-column label="操作" :width="80*zoomFactor" fixed="right" v-if="!dataLabel">
          <template slot-scope="scope">
            <div class="action-btn">
              <el-tooltip content="编辑" placement="top" effect="light" :open-delay="1000" :enterable="false">
                <Icon name="icon-edit" @click="openEditDialog(scope.row)" :disabled="permissionLevel <= PermissionLevel.LOOKER"></Icon>
              </el-tooltip>
              <el-tooltip content="删除" placement="top" effect="light" :open-delay="1000" :enterable="false">
                <Icon name="icon-ashbin" @click="deleteOne(scope.row)" :disabled="permissionLevel <= PermissionLevel.LOOKER"></Icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- API表数据 -->
    <div class="table-box2Uni"  v-if="apiOriginTableData.length && dataSourceType === 'API'">
      <el-table
        stripe
        :data="apiTableData"
        height="100%"
        tooltip-effect="dark"
        style="width: 100%"
      >
      <el-table-column
        label="键值"
        :width="80*zoomFactor"
        >
        别名
        </el-table-column>
        <el-table-column
            v-for="(item ,index) in apiOriginTableData"
            :key="index"
            :prop="index.toString()"
            :label="item.key"
            :width="item.width?item.width:auto"
            show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
  <div class="right" v-else>
    <Empty2 class="empty2"></Empty2>
  </div>
  <!--  重命名弹框-->
  <Rename :show.sync="showRenameDialog" :data="renameData" @refreshTable="refreshTable3"></Rename>
  <!--  上传表数据弹框-->
  <UploadTable ref="UploadTable" :allApiData="allApiData" :show.sync="showAddDialog" @openDialog="openDialog"></UploadTable>
  <!--  api 编辑表单弹框-->
  <EditApiFrom :apiEditFormData="apiEditFormData" :show.sync="showApiEditDialog" @refreshTable="refreshTable2"></EditApiFrom>
  <!--  新增表单数据-->
  <AddForm :show.sync="showAddFormDialog" @refreshTable="refreshTable2" :columns="columns" :tableId="tableId"></AddForm>
  <!--  编辑表单数据-->
  <EditForm :show.sync="showEditFormDialog" @refreshTable="refreshTable2" :columns="columns" :currentRow="currentRow" :tableId="currentId"></EditForm>
</div>
</template>

<script>
import UploadTable from './Dialog/UploadTable'
// import EditApiFrom from './Dialog/EditApiFrom'
import Rename from './Dialog/Rename'
import AddForm from './Dialog/AddForm'
import EditForm from './Dialog/EditForm'
import { downloadFile } from '@/utils/util'
import { getDataList, getApiDetails, getDetailsV2, httpApiSelect, deleteTable, deleteRowData } from '@/api/dataManagement'
import { PermissionLevel } from '@/configs/constants'
import { mapGetters } from 'vuex'
export default {
  name: 'ControlPlatform',
  props: {},
  components: { UploadTable, EditApiFrom: () => import('./Dialog/EditApiFrom'), Rename, AddForm, EditForm },
  data () {
    return {
      allApiData: [],
      columns: [],
      tableData: [],
      apiOriginTableData: [], // api 原始数据
      apiTableData: [{}], // api表格数据
      apiEditFormData: {}, // api 编辑表单数据
      showDialog: false,
      showRenameDialog: false,
      showApiEditDialog: false,
      showAddDialog: false,
      total: 0,
      pageParams: {
        name: '',
        pageNumber: 1,
        pageSize: 1000,
        dataSourceTypes: ['EXCEL', 'API']
      },
      activeIndex: 0,
      dataName: '', // 表名称
      dataLabel: '',
      dataSourceType: '', // 数据源类型
      dataList: [], // 数据列表
      renameData: null, // 被重命名的数据
      typeCheckList: ['EXCEL', 'API'],
      showId: undefined,
      timer: null,
      detailsParams: {
        id: '',
        pageNumber: 1,
        pageSize: 50
      },
      isNext: false, // 判断是否有下一页
      // eslint-disable-next-line no-dupe-keys
      showAddFormDialog: false,
      baseurl: process.env.VUE_APP_API_BASE_URL,
      currentId: null,
      tableId: null, // 新增表格行tableId
      currentRow: null,
      showEditFormDialog: false,
      coordinatesType: '',
      keep: true,
      PermissionLevel
    }
  },
  computed: {
    ...mapGetters(['permissionLevel'])
  },
  mounted () {
    this.getHttpApiSelect()
    this.getDataList()
  },
  methods: {
    // 文件下載
    async downloadFile (url, name) {
      try {
        await downloadFile(url, name)
      } catch {
        this.$message.error('下载文件失败')
      }
    },
    setShowId (item) {
      this.showId = item.id
    },
    open () {
      this.showDialog = true
    },
    // 点击左边li
    handleClick (index, item) {
      this.dataSourceType = item.dataSourceType
      this.total = 0
      this.activeIndex = index
      this.dataName = item.name
      this.dataLabel = item.label
      this.getDetails(item.id)
      this.currentId = item.id
    },

    openDialog () {
      this.getHttpApiSelect()
      this.getDataList()
    },
    openApiEditDialog () {
      this.getDataList()
      // this.showApiEditDialog = false
    },
    changeTypeCheckList () {
      this.pageParams.dataSourceTypes = this.typeCheckList
      this.getDataList()
    },
    onShowAddDialog () {
      if (this.permissionLevel <= PermissionLevel.LOOKER) {
        return
      }
      this.showAddDialog = true
    },
    // 获取数据列表
    getDataList () {
      getDataList(this.pageParams).then(res => {
        if (res.code === 200) {
          // res.data.records.forEach(v => {
          //   v.name = decodeURIComponent(v.name)
          // })
          this.dataList = res.data.records
          if (this.dataList.length) {
            this.dataSourceType = this.dataList[0].dataSourceType
            this.currentId = this.dataList[0].id
            this.dataName = this.dataList[0].name
            this.dataLabel = this.dataList[0].label
            this.activeIndex = 0
            this.getDetails(this.dataList[0].id)
          } else {
            this.dataName = ''
            this.dataLabel = ''
            this.tableData = []
            // this.total = res.data.total
          }
        }
      })
    },
    // 搜索表
    searchTable () {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.pageParams.dataSourceTypes = this.typeCheckList
      this.timer = setTimeout(() => {
        getDataList(this.pageParams).then(res => {
          if (res.code === 200) {
            this.dataList = res.data.records
          }
        })
      }, 500)
    },
    // 获取表详情
    // getDetails (id) {
    //   this.detailsParams.id = id
    //   this.detailsParams.pageNumber = 1
    //   getDetailsV2(this.detailsParams).then(res => {
    //     if (res.code === 200) {
    //       this.isNext = res.data.data.next
    //       this.coordinatesType = res.data.coordinatesType
    //       this.columns = []
    //       res.data.properties.forEach(item => {
    //         this.columns.push({
    //           uniqueId: item.uniqueId,
    //           id: item.id,
    //           prop: item.id.toString(),
    //           label: item.name,
    //           type: item.type,
    //           tag: item.tag,
    //           width: res.data.properties.length > 9 ? '203px' : 'auto' // 当列大于9列，强制设置每列长度为173，否则自适应
    //         })
    //       })
    //       this.tableData = res.data.data.records
    //       this.total = res.data.data.total
    //     }
    //   })
    // },
    getDetails (id) {
      if (this.dataSourceType === 'EXCEL') {
        this.detailsParams.id = id
        this.detailsParams.pageNumber = 1
        getDetailsV2(this.detailsParams).then(async (res) => {
          if (res.code === 200) {
            this.isNext = res.data.excelData.data.next
            this.coordinatesType = res.data.coordinatesType
            // this.coordinatesType = 'WGS84'
            this.columns = []
            res.data.excelData.properties.forEach(item => {
              this.columns.push({
                uniqueId: item.uniqueId,
                id: item.id,
                prop: item.id.toString(),
                label: item.name,
                type: item.type,
                tag: item.tag,
                width: res.data.excelData.properties.length > 9 ? 203 * this.zoomFactor : 'auto' // 当列大于9列，强制设置每列长度为173，否则自适应
              })
            })
            this.tableData = res.data.excelData.data.records
            this.total = res.data.excelData.data.total
            this.tableId = res.data.excelData.id

            this.keep = false
            await this.$nextTick()
            this.keep = true
          }
        })
      }
      if (this.dataSourceType === 'API') {
        getApiDetails({ id }).then(res => {
          if (res.code === 200) {
            // api 编辑表单数据
            this.apiEditFormData = res.data
            // api 原始数据 和 表头数据
            if (res.data.apiHttpConfig.alias.length > 8) {
              res.data.apiHttpConfig.alias.forEach(v => {
                v.width = 203 * this.zoomFactor
              })
            }
            this.apiOriginTableData = res.data.apiHttpConfig.alias
            // api表格数据
            res.data.apiHttpConfig.alias.forEach((v, i) => {
              this.$set(this.apiTableData[0], i.toString(), v.name)
            })
          }
        })
      }
    },
    customLabel (v) {
      if (v.tag) {
        const obj = {
          'LONGITUDE': '经度',
          'LATITUDE': '纬度',
          'HEIGHT': '高度'
        }
        const CoordName = {
          'BAIDU': '百度',
          'GAODE': '高德',
          'WSG84': 'WGS84'
        }
        return `${v.label}（设置为${obj[v.tag]}-${CoordName[this.coordinatesType]}）`
      } else {
        return v.label
      }
    },
    // 获取数据源下拉列表
    getHttpApiSelect () {
      httpApiSelect().then((res) => {
        this.allApiData = res.data
      })
    },
    // 删除表
    deleteTable (id) {
      const ids = []
      ids.push(id)
      this.$Delete({
        confirm: () => {
          deleteTable({ ids: ids }).then(res => {
            if (res.code === 200) {
              this.$Message('success', res.msg)
              this.getDataList()
              this.getHttpApiSelect()
            }
          })
        },
        cancel: () => {
        }
      })
    },
    // 点击重命名
    rename (item) {
      this.showRenameDialog = true
      this.renameData = item
    },
    refreshTable2 (v) {
      this.getDetails(this.currentId)
    },
    refreshTable3 (obj) {
      this.dataList.forEach(v => {
        if (v.id === obj.id) {
          v.name = obj.name
        }
      })
    },
    // 滚动底部加载更多
    loadMore () {
      // 判断有下一页才页码加一
      if (this.isNext) {
        this.detailsParams.pageNumber++
        getDetailsV2(this.detailsParams).then(res => {
          if (res.code === 200) {
            this.isNext = res.data.excelData.data.next
            this.tableData = this.tableData.concat(res.data.excelData.data.records)
            this.total = res.data.excelData.data.total
          }
        })
      }
    },
    // 添加一行数据
    openAddForm () {
      this.showAddFormDialog = true
    },
    // 编辑API数据
    openEditApiForm () {
      // this.showFormDialog = true
    },
    // 编辑一行数据
    openEditDialog (row) {
      this.currentRow = null
      setTimeout(() => {
        this.currentRow = row
      }, 100)
      this.showEditFormDialog = true
    },
    // 删除一行数据
    deleteOne (row) {
      console.log('delete: ', row)
      const ids = []
      ids.push(row.uniqueId)
      this.$Delete({
        confirm: () => {
          deleteRowData({ ids: ids }).then(res => {
            if (res.code === 200) {
              this.$Message('success', res.msg)
              this.refreshTable2()
            }
          })
        },
        cancel: () => {
        }
      })
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.dataManagement.as2sa{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  font-size: 30px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  .left{
    width: 280px;
    height: 100%;
    background: #272829;
    border-right: 1px solid rgba(255, 255, 255, 0.05);
    padding: 20px 16px;
    box-sizing: border-box;
    padding-right: 0;
    .searchBox{
      width: 100%;
      margin-bottom: 20px;
      height: 32px;
      display: flex;
      align-items: center;
      .searchInput{
        width: 165px;
      }
      .filter{
        width: 32px;
        height: 32px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 8px;
        img{
          width: 16px;
        }
      }
      .add{
        width: 32px;
        height: 32px;
        background: #00A4F0;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: white;
        &[disabled]{
          background:rgba(0, 164, 240, 0.6);
          cursor:not-allowed;
          // pointer-events: none;
        }
      }
    }
    .ul-box{
      height: 96%;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .dataList{
      padding: 0;
      height: 95%;
      >li{
        width: 248px;
        height: 32px;
        list-style: none;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 300;
        color: #CCCCCC;
        cursor: pointer;
        text-align: left;
        padding-left: 8px;
        box-sizing: border-box;
        border-radius: 6px;
        transition: all 0.3s;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 2px;
        position: relative;
        &:hover{
          background: rgba(255, 255, 255, 0.1);
          color: white;
          .img{
            opacity: 1;
          }
          .more{
            opacity: 1;
          }
          svg{
            opacity: 1!important;
          }
        }
        &.active{
          background: #334966;
          color: white;
          .img{
            opacity: 1;
          }
          .more{
            opacity: 1;
          }
        }
        .img{
          width: 14px;
          height: 16px;
          opacity: 1;
          margin-right: 7px;
        }
        .name{
          display: inline-block;
          width: calc(100% - 40px);
          @include show_ellipsis(1);
        }
        .more{
          float: right;
          opacity: 0;
          transform: translateY(3px);
          .el-icon-more{
            transform: translateY(1px) rotate(90deg);
            font-size: 14px;
          }
        }
      }
    }
  }
  .right{
    padding: 20px;
    box-sizing: border-box;
    flex: 1;
    height: 100%;
    overflow: hidden;
    .head{
      padding-bottom: 20px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      margin-bottom: 17px;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 300;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      >img{
        width: 14px;
        height: 16px;
        margin-right: 7px;
        background: #53d39c;
      }
      .addBtn{
        position: absolute;right: 20px;
      }
    }
    .total{
      font-size: 12px;
      font-family: Source Han Sans SC;
      font-weight: 300;
      color: #999999;
      text-align: left;
      margin-bottom: 12px;
      >span{
        color: white;
        font-size: 13px;
        margin: 0 4px;
      }
    }
    .table-box{
      /*height: 766px;*/
      height: calc(100% - 83px);
      overflow: auto;
      .el-table{
        background: #272829;
        .el-table__row{
          background-color: #272829 !important;
        }
      }
      .el-table__body-wrapper{
        height: calc(100% - 40px) !important;
      }
    }
    .table-box2Uni{
  height:calc(100% - 51px);
    overflow: auto;
    .el-table{
      background: #272829;
      .el-table__row{
        background-color: #272829 ;
      }
      .el-table__body-wrapper.is-scrolling-left,
      .el-table__body-wrapper.is-scrolling-middle,
      .el-table__body-wrapper.is-scrolling-right {
        height: 758px !important;
      }
    }
}
  }
}
.typeCheckList{
  .el-checkbox-group{
    display: flex;
    flex-direction: column;
    .el-checkbox{
      margin: 10px;
    }
  }
}
.renameDialog{
  .el-dialog{
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.4);
    .el-dialog__header{
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      padding: 10px !important;
      border: 0;
      padding-left: 20px !important;
    }
    .el-dialog__body{
      padding-left: 20px;
      padding-right: 20px;
    }
  }
}
.exportBtnByDataManagement{
  color: white !important;
  display: inline-block;
  width: 103px;
  height: 32px;
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 8px;
  line-height: 32px;
}
</style>
<style lang="scss" scoped>
.empty2{
    position: absolute;
    top: 30%;
    left: 0;
    right: 0;
  }
</style>
